import NetworkLogic from "../../Shared/NetworkLogic";
import Utils from "../../Shared/Utils";
import UIManager from "../../Shared/UIManager";
import Player from "../../Models/Player";
import SDKManager from "../../Shared/SDKManager";
import CQRCode from "../../Shared/CQRCode";
import Constant from "../../Shared/Constant";
import AudioManager from "../../Shared/AudioManager";
import {Global} from "../../Shared/Global";
import TuiGuangLayer from "./TuiGuangLayer";
const {ccclass, property} = cc._decorator;

@ccclass
export default class MyAgent extends cc.Component {
    @property(cc.Node)
    iconGold : cc.Node = null;
    @property(cc.Button)
    btnBind: cc.Button = null;
    @property(cc.Button)
    btnShareReceive: cc.Button = null;//
    @property(cc.Button)
    btnLingQu: cc.Button = null;//
    @property(cc.Node)
    playerBalanceUI: cc.Node = null;//
    // @property(cc.Node)
    // baoxiangAni: cc.Node = null;
    @property(cc.Label)
    userId: cc.Label = null;//返佣总额
    @property(cc.Label)
    grandTotalMoney: cc.Label = null;//返佣总额
    @property(cc.Label)
    returnMoney: cc.Label = null;//可领取佣金

    //人数
    @property(cc.Label)
    subordinate: cc.Label = null;//直属下级人数
    @property(cc.Label)
    noSubordinate: cc.Label = null;//非直属人数
    @property(cc.Label)
    yesterdayNum: cc.Label = null;//直属新增人数
    @property(cc.Label)
    yesyerdayNumNo: cc.Label = null;//下级新增人数

    //奖励
    @property(cc.Label)
    subordinateMoney: cc.Label = null;//直属金额
    @property(cc.Label)
    noSubordinateMoney: cc.Label = null;//非直属金额
    @property(cc.Label)
    shareMoney: cc.Label = null;//分享佣金
    @property(cc.Label)
    promoteTheAddress: cc.Label = null;//分享链接

    //二维码
    @property(CQRCode)
    QRCode: CQRCode = null;//二维码
    @property(cc.Sprite)
    test: cc.Sprite = null;//二维码
    @property(cc.Node)
    shareDetails: cc.Node = null;//分享记录
    @property(cc.Node)
    ReceiveRecords: cc.Node = null;//领取记录
    @property(cc.Node)
    nodeShare: cc.Node = null;//分享图片节点
    share = null;
    codeAddress = ""

    onLoad () {
        this.shareDetails.active = false;
        this.ReceiveRecords.active = false;
        this.nodeShare.active = false;
        cc.game.on(cc.game.EVENT_SHOW, this.onGameShow, this);
    }

    start () {

        this.userId.string = Player["userID"];
        this.node.active = false;
        UIManager.showLoadingUI();
        NetworkLogic.agentInfo(function (data) {
            console.log("=== 代理首页数据data:",data);
            this.share = data.returnGeneralizeShare;
            this.grandTotalMoney.string = data.grandTotalMoney;
            this.returnMoney.string = data.returnMoney;

            this.subordinate.string = data.subordinate;
            this.noSubordinate.string = data.noSubordinate;
            this.yesterdayNum.string = data.yesterdayNum;
            this.yesyerdayNumNo.string = data.yesyerdayNumNo;

            this.subordinateMoney.string = data.subordinateMoney;
            this.noSubordinateMoney.string = data.noSubordinateMoney;
            this.shareMoney.string = data.shareMoney;

            let promoteTheAddress = data.returnGeneralizeShare.promoteTheAddress;
            //let channelCode = data.channelCode;
            //let address  = "http://new5878.com?" + "channelCode="+ channelCode + "&code=" + data.agentCode
            // if  (data.returnGeneralizeShare.shortType){
            //     //生成二维码
            //     this.QRCode.string = promoteTheAddress;
            //     //复制链接
            //     this.promoteTheAddress.string = promoteTheAddress;
            // }else{
            //     this.QRCode.string = address;
            //     //复制链接
            //     this.promoteTheAddress.string = address;
            // }

            //生成二维码
            this.QRCode.string = promoteTheAddress;
            //复制链接
            this.promoteTheAddress.string = promoteTheAddress;
            this.codeAddress = promoteTheAddress
            this.node.active = true;
            NetworkLogic.bindWeChatInfo({},function (rec) {
                UIManager.hideLoadingUI();
                cc.log("====查询微信状态rec:",rec);
                if (rec){
                    this.btnBind.node.getChildByName("labBind").getComponent(cc.Label).string = "绑定成功";
                    this.btnBind.interactable = false;
                }
            }.bind(this),function () {
                UIManager.hideLoadingUI();
                cc.log("====查询微信状态错误");
            }.bind(this))


            let tuiGuangLayer : TuiGuangLayer = this.node.parent.parent.getComponent("TuiGuangLayer");
            if (tuiGuangLayer.jumpBindWechat){
                cc.log("===进入绑定微信");
                this.onBtnBind();
                tuiGuangLayer.jumpBindWechat = false;
            }

        }.bind(this),function () {
            UIManager.hideLoadingUI();
        }.bind(this));

    }
    onBtnClick(event,param){
        AudioManager.playSound("button");
        if (param === "0"){//分享领取奖励
            let data = {
                "receiveType": 0,
                "userId": Player.getPy("userID")
            }
            this.btnShareReceive.interactable = false;
            UIManager.showLoadingUI();
            NetworkLogic.agentReceivReword(data,function () {
                console.log("====收到领奖 data：",data);
                this.btnShareReceive.interactable = true;
                UIManager.hideLoadingUI();
                //开宝箱
                cc.director.emit(Global.UserEvent.OpenBaoxiang,this.shareMoney.string);
                this.shareMoney.string = 0;

                //更新金币，暂时没有
                this.playerBalanceUI.getComponent("PlayerBalanceUI").pullMoney(0);
            }.bind(this),function () {
                this.btnShareReceive.interactable = true;
                console.log("===领奖错误");
            }.bind(this));
        }
        else if(param === "1"){//佣金领取奖励
            let data = {
                "receiveType": 1,
                "userId": Player.getPy("userID")
            }
            UIManager.showLoadingUI();
            this.btnLingQu.interactable = false;
            NetworkLogic.agentNewReceivReword(data,function () {
                this.btnLingQu.interactable = true;
                UIManager.hideLoadingUI();
                //开宝箱
                cc.director.emit(Global.UserEvent.OpenBaoxiang,this.returnMoney.string)
                this.returnMoney.string = 0;
                //更新金币，暂时没有
                this.playerBalanceUI.getComponent("PlayerBalanceUI").pullMoney(0);
            }.bind(this),function () {
                this.btnLingQu.interactable = true;
                console.log("===领奖错误");
            }.bind(this));
        }
        else if (param === "shareReceiveInfo"){//分享领取记录
            this.shareDetails.active = true;

        }else if (param === "receiveRecord"){//领取记录
            this.ReceiveRecords.active = true;
        }
        else if (param === "save"){// 保存图片
            UIManager.showLoadingUI()
            NetworkLogic.getQrcodeImage2(function (data) {
                UIManager.hideLoadingUI()
                data.qrcodeList && data.qrcodeList[0] && cc.loader.load(data.qrcodeList[0].qrCodePath, function (err, texture) {
                    if (!err && cc.isValid(this.nodeShare)) {
                        this.nodeShare.active = true
                        this.nodeShare.getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
                        this.nodeShare.getChildByName("qrCode").getComponent(CQRCode).string = this.QRCode.string
                        Utils.saveNodeImageToAlbum(this.nodeShare, "tuiguang_share.jpg", function (success) {
                            if (success) {
                                UIManager.showToastUI('保存图片成功', Global.ToastType.OK)
                            } else {
                                UIManager.showTipUI("保存图片失败。请前往手机设置页面，打开本应用存储图片的权限")
                            }
                        }.bind(this))
                        this.nodeShare.active = false
                    }
                }.bind(this))
            }.bind(this))
        }
        else if (param === "copy"){//复制地址
            Utils.copyText(this.codeAddress);
            UIManager.showToastUI("复制成功")
        }
        else if (param === "qq"){//qq分享
            UIManager.showLoadingUI();
            SDKManager.shareURL({
                url: this.codeAddress,
                platformType: SDKManager.UMSocialPlatformType.QQ,
                title: this.share.shareTitle,
                describe: this.share.shareText,
                thumbUrl: this.share.promoteTheAddress,
            },function (index) {
                UIManager.hideLoadingUI();
                cc.log("=====qq分享param：",index);
                if (index === 0 || index === "0"){
                    UIManager.showTipUI("分享失败，请安装或检查QQ后重试")
                }
            }.bind(this))

        }
        else if (param === "wx"){//微信分享
            UIManager.showLoadingUI();
            SDKManager.shareURL({
                url: this.codeAddress,
                platformType: SDKManager.UMSocialPlatformType.WechatSession,
                title: this.share.shareTitle,
                describe: this.share.shareText,
                thumbUrl: this.share.promoteTheAddress,
            },function (index) {
                UIManager.hideLoadingUI();
                if (index === 0 || index === "0"){
                    UIManager.showTipUI("分享失败，请安装或检查微信后重试")
                }
            }.bind(this))
        }
        else if (param === "pyq"){//朋友圈分享
            UIManager.showLoadingUI();
            SDKManager.shareURL({
                url: this.codeAddress,
                platformType: SDKManager.UMSocialPlatformType.WechatTimeLine,
                title: this.share.shareTitle,
                describe: this.share.shareText,
                thumbUrl: this.share.promoteTheAddress,
            },function (index) {
                UIManager.hideLoadingUI();
                if (index === 0 || index === "0"){
                    UIManager.showTipUI("分享失败，请安装或检查微信后重试")
                }
            }.bind(this))
        }
        else if (param === "share") {
            UIManager.showLoadingUI()
            NetworkLogic.getQrcodeImage2(function (data) {
                UIManager.hideLoadingUI()
                data.qrcodeList && data.qrcodeList[0] && cc.loader.load(data.qrcodeList[0].qrCodePath, function (err, texture) {
                    if (!err && cc.isValid(this.nodeShare)) {
                        this.nodeShare.active = true
                        this.nodeShare.getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
                        this.nodeShare.getChildByName("qrCode").getComponent(CQRCode).string = this.QRCode.string
                        Utils.saveNodeImage(this.nodeShare, "tuiguang_share.jpg")
                        Utils.share("", jsb.fileUtils.getWritablePath() + "tuiguang_share.jpg", "")
                        this.nodeShare.active = false
                    }
                }.bind(this))
            }.bind(this))
        }
    }

    getGoldPos(){
        let outPos = this.iconGold.parent.convertToWorldSpaceAR(this.iconGold.getPosition());
        let nodepos = this.node.parent.parent.convertToNodeSpaceAR(outPos);
        return nodepos;
    }

    // btn  绑定微信
    onBtnBind(event,param){
        AudioManager.playSound("button");
        UIManager.showLoadingUI();
        SDKManager.getUserInfo(SDKManager.UMSocialPlatformType.WechatSession, function (data) {
            cc.log("====绑定微信data：",JSON.stringify(data));
            if(JSON.stringify(data) == "{}"){//苹果失败
                cc.log("====绑定苹果失败");
                UIManager.hideLoadingUI();
                UIManager.showTipUI("绑定失败，请安装或检查微信后重试");
                return;
            }
            if (data === 0 || data === "0"){//安卓失败
                cc.log("====绑定安卓失败");
                UIManager.hideLoadingUI();
                UIManager.showTipUI("绑定失败，请安装或检查微信后重试");
                return;
            }
            else if (data === 1 || data === "1"){
                UIManager.hideLoadingUI();
                return;
            }

            let  sendData = {
                "accessToken": data.accessToken,
                "appid": Constant.WeChatAppID,
                "iconurl": data.iconurl,
                "name": data.name,
                "openid": data.openid,
                "unionid": data.unionId,
                "userId": Player.getPy("userID"),
                "deviceFlag": ""
            }

            NetworkLogic.bindWeChat(sendData,function (rec) {
                cc.log("=====绑定微信成功rec:",rec);
                UIManager.hideLoadingUI();
                if (rec.code == 200) {
                    this.btnBind.node.getChildByName("labBind").getComponent(cc.Label).string = "绑定成功";
                    this.btnBind.interactable = false;
                    UIManager.showTipUI("绑定成功");
                }else{
                    UIManager.showTipUI(rec.msg || '微信授权后，保存用户信息失败！');
                }
            }.bind(this),function () {
                UIManager.hideLoadingUI();
                UIManager.showTipUI("绑定失败，请检查网络后重试");
                cc.log("=====绑定微信错误");
            });
        }.bind(this))
    }

    onGameShow () {
        UIManager.hideLoadingUI();
        cc.log("===切回来，重新隐藏Loading");
    }

    protected onDestroy(): void {
        cc.game.off(cc.game.EVENT_SHOW, this.onGameShow, this);
    }
}
